export class Revision {
  constructor (version) {
    this.version = version;
  }

  version = null

  _compareVersion (ver1, ver2) {
    ver1 = ver1.split('.').map(s => s.padStart(10)).join('.');
    ver2 = ver2.split('.').map(s => s.padStart(10)).join('.');
    return ver1 <= ver2;
  }

  deprecateInVersion (version, cb) {
    const isCurrentLatest = this.version === 'latest';
    const isNewerOrEqual = isCurrentLatest || this._compareVersion(version, this.version);
    if (!isNewerOrEqual) { cb(); }
  }

  introduceInVersion (version, cb) {
    const isCurrentLatest = this.version === 'latest';
    const isNewerOrEqual = isCurrentLatest || this._compareVersion(version, this.version);
    if (isNewerOrEqual) { cb(); }
  }
}
let singleton;
export function createRevisionHelpers (version) {
  singleton = new Revision(version);
}

export const revisionHelpers = {
  deprecateInVersion (...args) {
    return singleton && singleton.deprecateInVersion(...args);
  },
  introduceInVersion (...args) {
    return singleton && singleton.introduceInVersion(...args);
  },
};
